const assetLoader = () => {
  let endpoint = 'https://ackodrive-dev.ackoassets.com/_next_static'
  if (
    process.env.ACKO_ENV === 'dev' ||
    process.env.ACKO_ENV === 'uat' ||
    process.env.NEXT_PUBLIC_ACKO_ENV === 'dev' ||
    process.env.NEXT_PUBLIC_ACKO_ENV === 'uat'
  ) {
    endpoint = 'https://ackodrive-dev.ackoassets.com/_next_static'
  } else if (process.env.ACKO_ENV === 'prod' || process.env.NEXT_PUBLIC_ACKO_ENV === 'prod') {
    endpoint = 'https://ackodrive-prod.ackoassets.com/_next_static'
  }
  /*   else if (process.env.NEXT_PUBLIC_ACKO_ENV === "local") {
    endpoint = "";
  } else {
    endpoint = "/v2";
  } */
  return endpoint
}

export default assetLoader

export const s3UrlLoader = () => {
  let endpoint = 'https://ackodrive-prod.ackoassets.com/image'
  if (
    process.env.ACKO_ENV === 'dev' ||
    process.env.ACKO_ENV === 'uat' ||
    process.env.NEXT_PUBLIC_ACKO_ENV === 'dev' ||
    process.env.NEXT_PUBLIC_ACKO_ENV === 'uat'
  ) {
    endpoint = 'https://ackodrive-prod.ackoassets.com/image'
  } else if (process.env.ACKO_ENV === 'prod' || process.env.NEXT_PUBLIC_ACKO_ENV === 'prod') {
    endpoint = 'https://ackodrive-prod.ackoassets.com/image'
  }
  return endpoint
}
